import React, { useState } from "react";
import "./navbar.css";
import logo from "../../../img/a3maal (1).png";
import logo2 from "../../../img/a3maal (2).png";
import { Container, Nav, Navbar, Offcanvas } from "react-bootstrap";
import DropdownM from "../sidebar/dropdown";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import { Fade } from "react-awesome-reveal";
// import { useDispatch, useSelector } from "react-redux";
// import { GetAllFilessAction } from "../../../redux/actions/FileAction";
const Navbarr = ({
  isAdmin,
  isUser,
  Logout,
  userData,
  isEditor,
  notNumber,
}) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // const dispatch = useDispatch();
  // const { Files } = useSelector((state) => state.FileR);
  const goNot = () => {
    window.location.href = "/user/notifications";
  };
  const logout = () => {
    localStorage.removeItem("tokenajindamuhami");
    localStorage.removeItem("userajindamuhami");
  

    setTimeout(() => (window.location.href = "/login"), 1000);
  };
  const activeLink = () => {
    const link = document.querySelectorAll(".nn a");
    link.forEach((act) => {
      act.addEventListener("click", function () {
        link.forEach((btn) => btn.classList.remove("active"));
        this.classList.add("active");
      });
    });
  };
  useEffect(() => {
    // dispatch(GetAllFilessAction());
    activeLink();
  }, []);
  return (
    <div className="nnave">
      {isAdmin === true || isUser === true || userData !== null ? (
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand>
              <div className="kaema">
                {" "}
                <i
                  style={{ cursor: "pointer" }}
                  onClick={handleShow}
                  className="fa fa-solid fa-bars"></i>{" "}
                القائمة{" "}
              </div>
            </Navbar.Brand>
            {/* {isAdmin === true ?
             (
              <h4 className="works">لوحة التحكم</h4>
            ) : (
              <h4 className="works">أعمال النقدية</h4>
            )} */}
            <div className="not-name">
              {/* {userData ? (
                <h4 className="username">
                  {
                    userData[
                      "http://schemas.xmlsoap.org/ws/2005/05/identity/Claims/name"
                    ]
                  }
                </h4>
              ) : null} */}
              {userData?.Name}
                {isAdmin === true ? (
                  ""
                ) : (
                  <>
                    <i onClick={goNot} className={`not fa-solid fa-bell`}></i>
                  <span className="noticount">{notNumber ===undefined||notNumber === 0 ? 0 : notNumber}</span>
                  </>
                )}
            </div>
            {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
            {/* <Navbar.Collapse id="basic-navbar-nav"> */}
            {/* <Nav className="me-auto">
            <NavDropdown title="الإدارة" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.3">تصدير</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">استيراد</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown title="إدارة القوائم" id="basic-nav-dropdown">
                <NavDropdown.Item href="#action/3.3">
                  قائمة الملفات{" "}
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.4">
                  قائمة المستخدم
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.4">
                  قائمة الحساب الرئيسي
                </NavDropdown.Item>
                <NavDropdown.Item href="#action/3.4">
                  قائمة الحساب الفرعي
                </NavDropdown.Item>
              </NavDropdown>
            </NavDropdown>
            <NavDropdown title="اللغة" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.3">العربية</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">الإنجليزية</NavDropdown.Item>
            </NavDropdown>
            <Nav.Link href="#home">مساعدة</Nav.Link>
            <Nav.Link href="#df">تسجيل الخروج</Nav.Link>
          </Nav> */}
            {/* </Navbar.Collapse> */}
          </Container>
        </Navbar>
      ) : (
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand>
              <a href="https://a3maalapps.com/">
                <img style={{ width: "75px" }} src={logo} alt="" />
              </a>
            </Navbar.Brand>
            {/* {isAdmin === "true" ? (
          <h4 className="works">لوحة التحكم</h4>
        ) : (
          <h4 className="works">أعمال النقدية</h4>
        )}
        {isAdmin === "true" ? (
          <h4 className="username">أسم الأدمن</h4>
        ) : isUser === "true" ? (
          <h4 className="username">أحمد سلامه</h4>
        ) : null}
        <i onClick={goNot} className="not fa-solid fa-bell"></i> */}
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto nn">
                {/* <NavDropdown title="الإدارة" id="basic-nav-dropdown">
          <NavDropdown.Item href="#action/3.3">تصدير</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item href="#action/3.4">استيراد</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown title="إدارة القوائم" id="basic-nav-dropdown">
            <NavDropdown.Item href="#action/3.3">
              قائمة الملفات{" "}
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">
              قائمة المستخدم
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">
              قائمة الحساب الرئيسي
            </NavDropdown.Item>
            <NavDropdown.Item href="#action/3.4">
              قائمة الحساب الفرعي
            </NavDropdown.Item>
          </NavDropdown>
        </NavDropdown>
        <NavDropdown title="اللغة" id="basic-nav-dropdown">
          <NavDropdown.Item href="#action/3.3">العربية</NavDropdown.Item>
          <NavDropdown.Divider />
          <NavDropdown.Item href="#action/3.4">الإنجليزية</NavDropdown.Item>
        </NavDropdown> */}
                <Nav.Link
                  className="active"
                  as={Link}
                  to="https://a3maalapps.com/">
                  الرئيسية {/* <Link to="/"> الرئيسية</Link> */}
                </Nav.Link>
                <Nav.Link as={Link} to="https://a3maalapps.com/#app2">
                  التطبيقات
                  {/* <Link to="/user/app">التطبيقات</Link> */}
                </Nav.Link>
                <Nav.Link as={Link} to="https://a3maalapps.com/#about">
                  من نحن
                  {/* <Link to="/user/about">من نحن</Link> */}
                </Nav.Link>
                <Nav.Link as={Link} to="https://a3maalapps.com/#contact">
                  اتصل بنا {/* <Link to="/user/help">اتصل بنا </Link> */}
                </Nav.Link>
                <Nav.Link as={Link} to="/login">
                  تسجيل الدخول {/* <Link to="/login">تسجيل الدخول </Link> */}
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
            <Navbar.Brand>
              <img style={{ width: "75px" }} src={logo2} alt="" />
            </Navbar.Brand>
          </Container>
        </Navbar>
      )}
      <Offcanvas className="sidee" show={show} onHide={handleClose}>
        <Offcanvas.Header closeButton>
          <Fade direction="right">
            <Offcanvas.Title className="tit">
              <a href="/user/mainuserpage">
                أجندة المحامي القضائية{" "}
                <i className="fa-solid fa-scale-balanced"></i>
              </a>
            </Offcanvas.Title>
          </Fade>
        </Offcanvas.Header>
        {userData !== null ? (
          isAdmin === true || isEditor === true ? (
            <Offcanvas.Body>
              <Fade direction="up">
                <DropdownM
                  icon={
                    <i
                      className="fa fa-solid fa-file"
                      style={{ color: "#333" }}></i>
                  }
                  title="لوحة التحكم"
                  notsub={isEditor ? true : false}
                  listdata={["إدارة الأدمن"]}
                  link={`${isAdmin ? "/admin/adminmanage" : ""}`}
                  // edit={isEditor?true:false}
                  manageAdmin={isEditor ? true : false}
                />
              </Fade>
              <Fade direction="up">
                {" "}
                <DropdownM
                  icon={
                    <i
                      className="fa fa-solid fa-user"
                      style={{ color: "#333" }}></i>
                  }
                  title="باقة الأشتراكات"
                  listdata={["إدارة الباقات"]}
                  notsub={isEditor ? true : false}
                  link={`${
                    isAdmin
                      ? "/admin/subscribepackage"
                      : userData.Claims.map((claim, idx) =>
                          claim.ClaimName === "إضافة باقة" &&
                          claim.IsSelected === true
                            ? "/editor/subscribepackage"
                            : null
                        )
                  }`}
                  edit={isEditor ? true : false}
                />
              </Fade>
              <Fade direction="up">
                {" "}
                <DropdownM
                  icon={
                    <i
                      className="fa-solid fa-gear"
                      style={{ color: "#333" }}></i>
                  }
                  title="بيانات المستخدمين"
                  listdata={["إدارة بيانات المستخدمين"]}
                  notsub={isEditor ? true : false}
                  link={`${
                    isAdmin
                      ? "/admin/usermanagement"
                      : userData.Claims.map((claim, idx) =>
                          claim.ClaimName === "بيانات المستخدمين" &&
                          claim.IsSelected === true
                            ? "/editor/usermanagement"
                            : null
                        )
                  }`}
                  edit={isEditor ? true : false}
                />
              </Fade>
              <Fade direction="up">
                {" "}
                <DropdownM
                  icon={
                    <i
                      className="fa-solid fa-gear"
                      style={{ color: "#333" }}></i>
                  }
                  title="بيانات المشتركين"
                  listdata={["إدارة بيانات المشتركين"]}
                  notsub={isEditor ? true : false}
                  link={`${
                    isAdmin
                      ? "/admin/usersubscribe"
                      : userData.Claims.map((claim, idx) =>
                          claim.ClaimName === "بيانات المشتركين" &&
                          claim.IsSelected === true
                            ? "/editor/usersubscribe"
                            : null
                        )
                  }`}
                  edit={isEditor ? true : false}
                />
              </Fade>
              <Fade direction="up">
                {" "}
                <DropdownM
                  icon={
                    <i
                      style={{ color: "#333" }}
                      className="fa-regular fa-envelope"></i>
                  }
                  title="الإميلات"
                  notsub={isEditor ? true : false}
                  listdata={["إدارة الإميلات"]}
                  link={`${
                    isAdmin
                      ? "/admin/emails"
                      : userData.Claims.map((claim, idx) =>
                          claim.ClaimName === "الايميلات" &&
                          claim.IsSelected === true
                            ? "/editor/emails"
                            : null
                        )
                  }`}
                  edit={isEditor ? true : false}
                />
              </Fade>
              {/* <Fade direction="up">
              {" "}
              <DropdownM
                icon={
                  <i
                    style={{ color: "#333" }}
                    className="fa-solid fa-comment"
                  ></i>
                }
                title="الرسائل"
                listdata={["إدارة الرسائل"]}
                link="/admin/sms"
              />
            </Fade> */}
              <Fade direction="up">
                {" "}
                <DropdownM
                  icon={
                    <i
                      style={{ color: "#333" }}
                      className="fa-solid fa-bell"></i>
                  }
                  title="إدارة الأشعارات"
                  listdata={["إدارة الأشعارات"]}
                  notsub={isEditor ? true : false}
                  link={`${
                    isAdmin
                      ? "/admin/notifications"
                      : userData.Claims.map((claim, idx) =>
                          claim.ClaimName === "الاشعارات" &&
                          claim.IsSelected === true
                            ? "/editor/notifications"
                            : null
                        )
                  }`}
                  edit={isEditor ? true : false}
                />
              </Fade>
              <Fade direction="up">
                {" "}
                <button className="logout" onClick={logout}>
                  {" "}
                  <i
                    className="fa-solid fa-right-from-bracket"
                    style={{ color: "#333" }}></i>
                  تسجيل خروج{" "}
                </button>
              </Fade>
            </Offcanvas.Body>
          ) : isUser === true ? (
            <Offcanvas.Body>
              {/* <DropdownM
              icon={
                <i className="fa-solid fa-user"></i>
              }
              title="الأعدادات"
              listdata={["مستخدم فرعي"]}
              link="/user/supuser"
            /> */}
              <DropdownM
                icon={<i className="fa-solid fa-file-circle-check"></i>}
                title="التوكيل"
                link="/user/maintwkel"
                // File={Files}
                listdata={["إدارة التوكيلات"]}
              />{" "}
              {/* <DropdownM
              icon={
                <i className="fa-solid fa-users"></i>
              }
              title="لجان"
              listdata={["إدارة لجان التسوية","إدارة لجان فض المنازعات"]}
             
              manage={"manage"}
            />{" "} */}
              <DropdownM
                icon={<i className="fa-solid fa-chalkboard-user"></i>}
                title="دعاوي"
                listdata={["إدارة الدعاوي"]}
                link="/user/dawemanage"
              />
              <DropdownM
                icon={<i className="fa-solid fa-gavel"></i>}
                title="الأجندة القضائية"
                listdata={["إدارة الأجندة القضائية "]}
                link="/user/ajindamuhami"
              />
              <DropdownM
                icon={<i className="fa-solid fa-file-circle-check"></i>}
                title="العمل الأداري"
                link="/user/managework"
                // File={Files}
                listdata={["إدارة العمل الأداري"]}
              />{" "}
              {/* <DropdownM
              icon={
                <i className="fa-solid fa-ranking-star"></i>
              }
              title="جدول الخبراء"
              listdata={["إدارة جدول الخبراء"]}
              link="/user/gadwalkh"
            />{" "}
            <DropdownM
              icon={
                <i className="fa-solid fa-scale-balanced"></i>
              }
              title="أعمال محضرين"
              listdata={[,,"إدارة اعلانات قضائية", " إدارة انذارات قانونية", "إدارة أوراق التنفيذ"]}
              manage = "manage" 
            />
            <DropdownM
              icon={
                <i className="fa-solid fa-people-roof"></i>
              }
              title="العمل الإداري"
              listdata={["إدارة العمل الإداري"]}
              link="/user/managework"
            />
            <DropdownM
              icon={
                <i className="fa-solid fa-laptop-file"></i>
              }
              title="دعاوي الحفظ"
              listdata={["إدارة دعاوي الحفظ"]}
              link="/user/dawehefz"
            />
            <DropdownM
              icon={
                <i className="fa-solid fa-briefcase"></i>
              }
              title="أعمال الشركات"
              listdata={[,,,,,"إدارة سجلات شركة","إدارة تعديلات سجل شركة","إدارة سجل الأجتماعات","إدارة لجان الطعن الضريبي"]}
              manage = "manage" 
            /> */}
              {/* <DropdownM
              icon={
                <i className="fa-solid fa-paperclip"></i> 
              }
              title="الأرشيف"
              listdata={["إدارة الأرشيف "]}
              link="/user/archives"
            />{" "} */}
              <DropdownM
                icon={<i className="fa-solid fa-user"></i>}
                title="الأعدادات"
                listdata={[
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  ,
                  "البيانات الشخصية",
                  "الأشتراكات",
                  "الأشعارات",
                ]}
                manage="manage"
              />{" "}
              <DropdownM
                icon={
                  <i
                    className="fa-solid fa-circle-info"
                    style={{ color: "#333" }}></i>
                }
                title="كيفية الأستخدام"
                listdata={["كيفية استخدام التطبيق"]}
                link="/user/howwork"
              />
              <DropdownM
                icon={
                  <i
                    className="fa-solid fa-circle-info"
                    style={{ color: "#333" }}></i>
                }
                title="مساعدة"
                listdata={["تواصل معنا"]}
                link="/user/help"
              />
              {/* <DropdownM
                icon={
          
                }
                title="تسجيل خروج"
                onClick={Logout}
              /> */}
              <button className="logout" onClick={logout}>
                {" "}
                <i
                  className="fa-solid fa-right-from-bracket"
                  style={{ color: "#333" }}></i>
                تسجيل خروج{" "}
              </button>
            </Offcanvas.Body>
          ) : null
        ) : null}
      </Offcanvas>
    </div>
  );
};

export default Navbarr;
